export const GET_TRACKED_ITEM_TYPES_SUCCESS = "GET_TRACKED_ITEM_TYPES_SUCCESS";
export const GET_SYSTEM_CREATED_TRACKED_ITEM_TYPES_SUCCESS = "GET_SYSTEM_CREATED_TRACKED_ITEM_TYPES_SUCCESS";
export const UPDATE_TRACKED_ITEM_TYPE_SUCCESS = "UPDATE_TRACKED_ITEM_TYPEUPDATE_SUCCESS";
export const ADD_TRACKED_ITEM_TYPE_SUCCESS = "ADD_TRACKED_ITEM_TYPE_SUCCESS";
export const INACTIVATE_TRACKED_ITEM_TYPE_SUCCESS = "INACTIVATE_TRACKED_ITEM_TYPE_SUCCESS";
export const ACTIVATE_TRACKED_ITEM_TYPE_SUCCESS = "ACTIVATE_TRACKED_ITEM_TYPE_SUCCESS";
export const EMPTY_TRACKED_ITEM_TYPE_SUCCESS = "EMPTY_TRACKED_ITEM_TYPE_SUCCESS";
export const GET_TRACKED_ITEM_TYPE_BY_SITE_SUCCESS = "GET_TRACKED_ITEM_TYPE_BY_SITE_SUCCESS";
export const GET_HIDDEN_TRACKED_ITEM_TYPES_SUCCESS = "GET_HIDDEN_TRACKED_ITEM_TYPES_SUCCESS";
